import React, {Component} from "react";
import '../../../node_modules/izitoast/dist/css/iziToast.min.css';
import {withTranslate} from "react-redux-multilingual"
import OwlCarousel from "react-owl-carousel";
import NoData from "./../NoData";
import OfferCard from "./../offers/OfferCard"
import {setOffersSkeleton} from "../../skeleton";
import SectionHeader from "./../../components/home/SectionHeader";
import {Link} from "react-router-dom";

class Offers extends Component {

    render() {
        const {offers, offersListIsLoading} = this.props;
        const offersList = offers && offers.length ? offers.map((offer, index) => {
            return (
                <div key={index}>
                    <Link to={"/offer/" + offer.id}>
                        <OfferCard language={this.props.language} offer={offer}/>
                    </Link>
                </div>
            )
        }) : null;
        return (
            <section className="offers-sec">
                <div className="container">
                    {this.props.isHome ? <div className="row">
                        <div className="col-md-12 center">
                            <SectionHeader header={this.props.translate("offer_header")}/>
                        </div>
                    </div> : null}

                    <div className="row">
                        <div className="col-md-12">
                            {
                                (
                                    offersListIsLoading === false ?
                                        (
                                            <div className="row">
                                                {
                                                    offers.length !== 0 ?
                                                        <OwlCarousel
                                                            className="owl-theme"
                                                            loop={false}
                                                            slideBy={1}
                                                            margin={40}
                                                            dots={true}
                                                            autoplay={true}
                                                            lazyLoad={true}
                                                            responsive={{
                                                                0: {
                                                                    items: 1
                                                                },
                                                                600: {
                                                                    items: 1
                                                                },
                                                                1000: {
                                                                    items: 2
                                                                }
                                                            }}>
                                                            {offersListIsLoading === false ? offersList : null}

                                                        </OwlCarousel>


                                                        : <NoData image="no-offers"/>
                                                }

                                            </div>

                                        ) :
                                        <div>
                                            <div className="flex-container">
                                                {
                                                    setOffersSkeleton(2)
                                                }
                                            </div>
                                        </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


export default withTranslate(Offers);


/// References ////////
//// https://www.npmjs.com/package/izitoast/v/1.0.2




